import { createFileRoute } from '@tanstack/react-router'

import DetailSubmissionPage from '@/components/pages/backoffice/_klb-petani/_petani/_$petaniId/lahan/submission/_$verificationId/container/DetailSubmissionPage'

export const Route = createFileRoute(
  '/_backoffice/klb-petani/petani/$petaniId/lahan/submission/$verificationId/'
)({
  component: DetailSubmissionPage
})
